import { Component, OnChanges, Input } from '@angular/core';
import { Activity } from '../../shared/activity';
import { BlobStorageService } from '../../../shared/blob-storage.service';
import { action } from '../../shared/action';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-activity-timeline-card',
  templateUrl: './activity-timeline-card.component.html',
  styleUrls: ['./activity-timeline-card.component.scss'],
})
export class ActivityTimelineCardComponent implements OnChanges {

  @Input() activity?: Activity;
  title = '';
  isLinkActive = false;
  hasImage = false;
  avatar$?: Observable<string>;
  loadingError = false;

  constructor(
    private _blobStorageService: BlobStorageService,
    private _sanitizer: DomSanitizer,
  ) { }

  ngOnChanges() {
    if (this.activity) {
      this.loadingError = false;
      this.hasImage = this.activity.action === action.INSERT || this.activity.action === action.REPLACE;
      this.isLinkActive = this.activity.action === action.INSERT || this.activity.action === action.REPLACE;

      this.title = this.activity.action === action.INSERT ? 'レシートを登録しました' :
        this.activity.action === action.REPLACE ? 'レシートを更新しました' :
          this.activity.action === action.DELETE ? 'レシートを削除しました' :
            this.activity.action === action.ARCHIVE ? '当月分を確定しました' : '';

      if (this.activity.createdBy?.id) {
        this.avatar$ = this._blobStorageService.getAvatar(this.activity.createdBy.id);
      }
    }
  }

  bypassSecurity(url: string) {
    return this._sanitizer.bypassSecurityTrustStyle(url);
  }
}
